// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"274":"Home","810":"NotFound","933":"Privacy"}[chunkId] + "." + {"274":"a684c28d","810":"de83c18c","933":"de9b8443"}[chunkId] + ".js";
};